import http from './../../http.js'

export const getMyTrainResults = data => {
	return http({
		url: '/user/GetMyTrainResults?ui_guid=' + data,
		method: 'get'
	})
};


// 签名
export const userUpdateUserSignature = data => {
	return http({
		url: '/user/UpdateUserSignature',
		method: 'post',
		data
	})
};


export const getTrainTimeResults = data => {
	return http({
		url: '/user/GetMyTrainTimeResults?ui_guid=' + data.id + "&type=" + data.type + "&parms=" + data
			.parms,
		method: 'get'
	})
};

export const getMyTrainDetailScoreSTA = data => {
	return http({
		url: '/user/GetMyTrainDetailScoreSTA?ui_guid=' + data.id + "&month=" + data.month,
		method: 'get'
	})
};

export const getMyComprehensiveSTA = data => {
	return http({
		url: '/user/GetMyComprehensiveSTA?ui_guid=' + data.id + "&sx_te_guid=&taskName=&startTime=&endTime",
		method: 'get'
	})
};

export const GetMyTrainDataList = data => {
	return http({
		url: '/user/GetMyTrainDataList?pageIndex=' + data.index + "&pageSize=" + data.size + "&ui_guid=" +
			data.ui_guid + "&taskName=" + data.taskName + "&startTime=" + data.startTime + "&endTime=" +
			data.endTime + "&projectName=" + data.projectName,
		method: 'get'
	})
};

export const GetMyTrainDataListApi = data => {
	return http({
		url: '/Model/GetMyTrainDataList?pageIndex=' + data.index + "&pageSize=" + data.size + "&ui_guid=" +
			data.ui_guid + "&taskName=" + data.taskName + "&startTime=" + data.startTime + "&endTime=" +
			data.endTime + "&projectName=" + data.projectName,
		method: 'get'
	})
};



export const getTraiDetailByTOPIDList = data => {
	return http({
		url: '/TrainingOrProject/GetTraiDetailByTOPIDList?taskName=' + data,
		method: 'get'
	})
};


export const getTraiDetailByTOPIDListApi = data => {
	return http({
		url: '/Model/GetTraiDetailByTOPIDList?TDT_TaskGuid=' + data,
		method: 'get'
	})
};


export const getTrainSTAByGUID = data => {
	return http({
		url: '/TrainingOrProject/GetTrainSTAByGUID?taskName=' + data,
		method: 'get'
	})
};

// 图表  实训图表
export const getTrainSTAByGUIDApi = data => {
	return http({
		url: '/Model/GetTrainSTAByGUID?TDT_TaskGuid=' + data,
		method: 'get'
	})
};


// 我的实训api

export const getMyAppointmentList = data => {
	return http({
		url: '/Appointment/GetMyAppointmentList?ap_applicantGuid=' + data.ap_applicantGuid + "&pageIndex=" +
			data.pageIndex + "&pageSize=" + data.pageSize + "&te_deviceName=" + data.te_deviceName,
		method: 'get'
	})
};

export const GetsxMyAppointmentList = data => {
	return http({
		url: '/Appointment/GetsxMyAppointmentList?ap_applicantGuid=' + data.ap_applicantGuid +
			"&pageIndex=" + data.pageIndex + "&pageSize=" + data.pageSize + "&te_deviceName=" + data
			.te_deviceName,
		method: 'get'
	})
};


// 取消预约

export const cancelAppointment = data => {
	return http({
		url: '/Appointment/CancelAppointment?sx_ap_guid=' + data,
		method: 'get'
	})
};

// 实训室列表不分页

export const getTrainEquipmentList = data => {
	return http({
		url: '/TrainEquipment/GetTrainEquipmentList?si_guid=' + data,
		method: 'get'
	})
};


export const getAppointmentSingle = data => {
	return http({
		url: '/Appointment/GetAppointmentSingle?sx_ap_guid=' + data,
		method: 'get'
	})
};

// 一键重置

export const setResetPassword = data => {
	return http({
		url: '/user/ResetPassword?ui_guid=' + data,
		method: 'get'
	})
};

// 上传头像

export const setUploadAvatar = data => {
	return http({
		url: "/user/UploadAvatar",
		method: 'post',
		data
	})
};

//  /Model/GetMyTrainTimeResults 个人首页实训时长
export const GetMyTrainTimeResultsApi = data => {
	return http({
		url: '/Model/GetMyTrainTimeResults?ui_guid=' + data.id + "&type=" + data.type + "&parms=" +
			data.parms,
		method: 'get'
	})
};


//  /Model/GetMyTrainTimeResults 实训成绩分析
export const GetMyTrainDetailScoreSTAApi = data => {
	return http({
		url: '/Model/GetMyTrainDetailScoreSTA?ui_guid=' + data.id + "&month=" + data.month,
		method: 'get'
	})
};